import { useContext, useEffect } from "react";
import { OutsetaContext } from "pages/_app";
import { useRouter } from "next/router";
import Link from "next/link";

export default function ChangePlan(props) {
  const { isOutsetaLoading } = useContext(OutsetaContext);
  const router = useRouter();
  const planSettingsLink = `/profiles/plan/settings${
    props.upgrade ? "?upgrade=true" : ""
  }`;

  // redirect to support any previous account settings direct links in the wild
  useEffect(() => {
    if (router.isReady && router.query?.showOutseta === "true") {
      router.push("/profiles/plan/settings");
    }
    // this is the next/router recommended solution, eslint doesn't like it.
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [router.isReady]);

  return (
    <>
      {!isOutsetaLoading && (
        <button
          className={
            props.className ??
            "font-semibold text-red text-sm uppercase border-0"
          }
        >
          <Link href={planSettingsLink}>{props.children}</Link>
        </button>
      )}
    </>
  );
}
